module.exports = __webpack_public_path__ + "media/images/s2ep5-cindy-97d66a66aeb1dea9cebf838597c73b83.png";